// 智慧管家 SmartBox API

// ===== 設備管理 =====

/**
 * @function ApiClient#GetSmartBoxDeviceList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.search
 * @param {any} params.status
 * @param {any} params.page
 * @param {any} params.pageSize
 * @param {any} options = {}
 */
export async function GetSmartBoxDeviceList(cid, { search = "", status = "", page = 1, pageSize = 15 } = {}, options = {}) {
  return await this._get(
    `/community/${cid}/smart_box/device_list?search=${encodeURIComponent(search)}&status=${status}&page=${page}&pageSize=${pageSize}`,
    options,
  );
}

/**
 * @function ApiClient#GetSmartBoxDevice
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} deviceId
 * @param {any} options = {}
 */
export async function GetSmartBoxDevice(cid, deviceId, options = {}) {
  return await this._get(`/community/${cid}/smart_box/device/${deviceId}`, options);
}

/**
 * @function ApiClient#PreBindSmartBox
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function PreBindSmartBox(cid, data, options = {}) {
  return await this._post(`/community/${cid}/smart_box/device`, data, options);
}

/**
 * @function ApiClient#UpdateSmartBox
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} deviceId
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateSmartBox(cid, deviceId, data, options = {}) {
  return await this._put(`/community/${cid}/smart_box/device/${deviceId}`, data, options);
}

/**
 * @function ApiClient#UpdateSmartBoxStatus
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} deviceId
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateSmartBoxStatus(cid, deviceId, data, options = {}) {
  return await this._put(`/community/${cid}/smart_box/device/${deviceId}/status`, data, options);
}

/**
 * @function ApiClient#UnbindSmartBox
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} deviceId
 * @param {any} options = {}
 */
export async function UnbindSmartBox(cid, deviceId, options = {}) {
  return await this._delete(`/community/${cid}/smart_box/device/${deviceId}`, options);
}

/**
 * @function ApiClient#RotateSmartBoxKey
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} deviceId
 * @param {any} options = {}
 */
export async function RotateSmartBoxKey(cid, deviceId, options = {}) {
  return await this._post(`/community/${cid}/smart_box/device/${deviceId}/rotate_key`, {}, options);
}

// ===== 控制區域 =====

/**
 * @function ApiClient#GetSmartBoxZoneList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetSmartBoxZoneList(cid, options = {}) {
  return await this._get(`/community/${cid}/smart_box/zone_list`, options);
}

/**
 * @function ApiClient#AddSmartBoxZone
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function AddSmartBoxZone(cid, data, options = {}) {
  return await this._post(`/community/${cid}/smart_box/zone`, data, options);
}

/**
 * @function ApiClient#UpdateSmartBoxZone
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} zoneId
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateSmartBoxZone(cid, zoneId, data, options = {}) {
  return await this._put(`/community/${cid}/smart_box/zone/${zoneId}`, data, options);
}

/**
 * @function ApiClient#DeleteSmartBoxZone
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} zoneId
 * @param {any} options = {}
 */
export async function DeleteSmartBoxZone(cid, zoneId, options = {}) {
  return await this._delete(`/community/${cid}/smart_box/zone/${zoneId}`, options);
}

// ===== 預設指令 =====

/**
 * @function ApiClient#GetSmartBoxPresetList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetSmartBoxPresetList(cid, options = {}) {
  return await this._get(`/community/${cid}/smart_box/preset_list`, options);
}

/**
 * @function ApiClient#AddSmartBoxPreset
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function AddSmartBoxPreset(cid, data, options = {}) {
  return await this._post(`/community/${cid}/smart_box/preset`, data, options);
}

/**
 * @function ApiClient#UpdateSmartBoxPreset
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} presetId
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateSmartBoxPreset(cid, presetId, data, options = {}) {
  return await this._put(`/community/${cid}/smart_box/preset/${presetId}`, data, options);
}

/**
 * @function ApiClient#DeleteSmartBoxPreset
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} presetId
 * @param {any} options = {}
 */
export async function DeleteSmartBoxPreset(cid, presetId, options = {}) {
  return await this._delete(`/community/${cid}/smart_box/preset/${presetId}`, options);
}

// ===== 指令紀錄 =====

/**
 * @function ApiClient#GetSmartBoxCommandLog
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.pageSize
 * @param {any} options = {}
 */
export async function GetSmartBoxCommandLog(cid, { page = 1, pageSize = 20 } = {}, options = {}) {
  return await this._get(`/community/${cid}/smart_box/command_log?page=${page}&pageSize=${pageSize}`, options);
}
